import { defineMessages } from "react-intl";

const validationMessages = defineMessages({
    invalidProductUid: {
        description: "Invalid productUid",
        defaultMessage: "Invalid productUid."
    },
    nameRequired: {
        description: "Name is required",
        defaultMessage: "Name is required."
    },
    fullNameRequired: {
        description: "Full name (first and last) is required",
        defaultMessage: "Please enter your first and last name."
    },
    nameTooLong: {
        description: "Name is too long",
        defaultMessage: "Please enter no more than {maxNameLength} characters."
    },
    companyNameRequired: {
        description: "Name of your organization is required",
        defaultMessage: "Name of your organization is required."
    },
    companyNameTooLong: {
        description: "Name of your organization is too long",
        defaultMessage: "Please enter no more than {maxCompanyNameLength} characters."
    },
    companyNameInvalidChars: {
        description: "Name of your organization contains invalid characters",
        defaultMessage: "Name of your organization contains invalid characters. Please remove special markup like \"<\" or \">\"."
    },
    emailRequired: {
        description: "Email is required",
        defaultMessage: "Email is required."
    },
    emailWrong: {
        description: "Email is wrong",
        defaultMessage: "Please provide a valid email address."
    },
    emailDomainInBlockedList: {
        description: "Email is in blocked list",
        defaultMessage: "Domain not accepted. Please try another email address."
    },
    emailRegistered: {
        description: "Email is registered",
        defaultMessage: "This email is already registered."
    },
    passwordRequired: {
        description: "Password is required",
        defaultMessage: "Password is required."
    },
    passwordRules: {
        description: "Password rules",
        defaultMessage: "Password must have at least {minLength} characters, with at least one: uppercase letter, lowercase letter, number, special character."
    },
    passwordDoNotMatch: {
        description: "Passwords do not match",
        defaultMessage: "Passwords do not match."
    },
    termsMustBeAccepted: {
        description: "Terms and Conditions must be accepted",
        defaultMessage: "Terms and Conditions must be accepted."
    },
    accountNameInvalid: {
        description: "Account/name is not valid",
        defaultMessage: "Please enter a valid name."
    },
    serverNameTooLong: {
        description: "First/last name is too long (server limit)",
        defaultMessage: "Please enter no more than {maxLength} characters for your name."
    },
    emailTooLong: {
        description: "Email is too long",
        defaultMessage: "Please enter no more than {maxLength} characters."
    },
    passwordTooLong: {
        // distinct description => distinct hashed id (same defaultMessage as emailTooLong)
        description: "Password is too long",
        defaultMessage: "Please enter no more than {maxLength} characters."
    },
    passwordOtherError: {
        description: "Password rejected by server policy",
        defaultMessage: "This password isn't allowed. Please choose a different one."
    },
    recaptchaFailed: {
        description: "reCAPTCHA verification failed",
        defaultMessage: "We couldn't verify that you're human. Please try again."
    },
    signupBlocked: {
        description: "Account creation blocked — contact sales",
        defaultMessage: "We're unable to create your account. Please <a>contact sales</a>."
    },
    genericError: {
        description: "Generic registration error fallback",
        defaultMessage: "Something went wrong. Please try again."
    },
    jobTitleRequired: {
        description: "Job title is required",
        defaultMessage: "Job title is required."
    },
    jobTitleTooLong: {
        description: "Job title is too long",
        defaultMessage: "Please enter no more than {maxJobTitleLength} characters."
    },
    jobTitleInvalidChars: {
        description: "Job title contains invalid characters",
        defaultMessage: "Job title contains invalid characters. Please remove special markup like \"<\" or \">\"."
    }
});

export default validationMessages;
